import { defineRouting } from "next-intl/routing";
import { defaultLocale, locales } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: {
    mode: "as-needed",
    prefixes: {
      "en-GB": "/en-gb",
      "zh-CN": "/zh-cn",
      "zh-TW": "/zh-tw",
      vi: "/vi",
      es: "/es",
      de: "/de",
      ko: "/ko",
      fr: "/fr",
      "pt-PT": "/pt-pt",
      "pt-BR": "/pt-br",
      pl: "/pl",
      nl: "/nl",
    },
  },
});
